<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="partClose" :disabled="!btn.partclose">{{$t('getapi[7879]')}}</el-button>
            <el-button type="primary" size="mini" @click="partBreak" :disabled="!btn.partbreak">{{$t('getapi[7880]')}}</el-button>
            <el-button type="primary" size="mini" @click="purAudit" :disabled="!btn.puraudit">{{$t('getapi[7881]')}}</el-button>
            <el-button type="primary" size="mini" @click="purClose" :disabled="!btn.purclose">{{$t('getapi[7882]')}}</el-button>
            <el-button type="primary" size="mini" @click="purBreak" :disabled="!btn.purbreak">{{$t('getapi[7883]')}}</el-button>
            <el-button type="primary" size="mini" @click="batchSearch">{{$t('getapi[8797]')}}</el-button>
            <el-button type="primary" size="mini" @click="searchExp">{{$t('getapi[8808]')}}</el-button>
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="FrmRFQView"
                :filter_language="['pur_status','part_status']"
                :filter_thousandth="['pur_moq','part_qty','part_year_qty']"
                :filter_thousandth_purprice="['pur_price']"
                :filter_date="['part_require_date']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight - reduceTableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[7884]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_blueprint_code" :label="$t('getapi[7885]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="rfq_n1" :label="$t('getapi[7886]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_status" :label="$t('getapi[7887]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_buyer" :label="$t('getapi[7888]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_vender" :label="$t('getapi[3685]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_require_date" :label="$t('getapi[7889]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_description" :label="$t('getapi[196]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_status" :label="$t('getapi[7890]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_price" :label="$t('getapi[7891]')" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_floor" :label="$t('getapi[7892]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_unit" :label="$t('getapi[7893]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_currency" :label="$t('getapi[1338]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_moq" :label="$t('getapi[7894]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_cycle" :label="$t('getapi[3597]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_delivery" :label="$t('getapi[7895]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_payment" :label="$t('getapi[6738]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_page" :label="$t('getapi[7896]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_qty" :label="$t('getapi[4287]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_item_type" :label="$t('getapi[134]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_year_qty" :label="$t('getapi[7897]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_unit" :label="$t('getapi[727]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_avl_text" :label="$t('getapi[7898]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_avl_code" :label="$t('getapi[7899]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_question" :label="$t('getapi[7900]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_reply" :label="$t('getapi[7901]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_create_date" :label="$t('getapi[7902]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_remark" :label="$t('getapi[7903]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_finish_date" :label="$t('getapi[7904]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_create_person" :label="$t('getapi[7905]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_create_time" :label="$t('getapi[7906]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_modify_person" :label="$t('getapi[7907]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_modify_time" :label="$t('getapi[7908]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_audit_person" :label="$t('getapi[7909]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_audit_time" :label="$t('getapi[7910]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_close_person" :label="$t('getapi[7911]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_close_time" :label="$t('getapi[7912]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_key" :label="$t('getapi[7913]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_key" :label="$t('getapi[7914]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_create_person" :label="$t('getapi[7915]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_create_date" :label="$t('getapi[7916]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_close_person" :label="$t('getapi[7917]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_close_time" :label="$t('getapi[7918]')"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FrmRFQView" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6547]')" queryData="FrmRFQView" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isVisibleSearch" width="25%">
            <div style="background: white;white-space: nowrap;">
                <el-button type="primary" size="mini" @click.native.prevent="addsearch">{{$t('getapi[6467]')}}</el-button>
                <el-button type="primary" size="mini" @click.native.prevent="delsearch">{{$t('getapi[7241]')}}</el-button>
            </div>
            <div style="display: flex">
                <vxe-table
                        :data="dataSearch"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="350"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        ref="search"
                        :auto-resize="true"
                >
                    <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                    <vxe-table-column field="part_code" :title="$t('getapi[8222]')" width="200">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.part_code" size="mini"></el-input>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
            <span slot="footer">
				<el-button type="primary" @click="getSearchView"  size="mini">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'purrfq',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purrfq'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                selectData: [],
                btn: {
                    partclose: false,
                    partbreak: false,
                    puraudit: false,
                    purclose: false,
                    purbreak: false,
                },
                //批量查询价格表单
                isVisibleSearch: false,
                dataSearch: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('FrmRFQView', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6547]"),this.$t("getapi[17]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.partclose = false
                that.btn.partbreak = false
                that.btn.puraudit = false
                that.btn.purclose = false
                that.btn.purbreak = false
                if(that.selectData.length > 0){
                    console.log('权限' + that.$limits.authority('plv4', 126, 1))
                    if(that.$limits.authority('plv4', 126, 1) > 0){
                        that.btn.partclose = that.selectData.every(val => {
                            return val.part_status != '关闭' && val.part_status != ''
                        });
                    }
                    if(that.$limits.authority('plv4', 127, 1) > 0){
                        that.btn.partbreak = that.selectData.every(val => {
                            return val.part_status == '关闭' && val.part_status != ''
                        });
                    }
                    if(that.$limits.authority('plv4', 128, 1) > 0){
                        that.btn.puraudit = that.selectData.every(val => {
                            return val.pur_status == '生成' && val.pur_status != ''
                        });
                    }
                    if(that.$limits.authority('plv4', 129, 1) > 0){
                        that.btn.purclose = that.selectData.every(val => {
                            return val.pur_status != ''
                        });
                    }
                    if(that.$limits.authority('plv4', 146, 1) > 0){
                        that.btn.purbreak = that.selectData.every(val => {
                            return val.pur_status != '生成' && val.pur_status != ''
                        });
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purrfq',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FrmRFQView');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/RFQB/PurRFQViewDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/RFQB/PurRFQViewExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "FrmRFQView",
                    fromname: that.$t("getapi[6547]"),
                    SelectIndex: that.SelectIndexs,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                console.log(val)
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            // 零件关闭
            partClose(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        part_key: that.selectData[i].part_key,
                        part_status: that.selectData[i].part_status,
                        part_modify_time: that.selectData[i].part_modify_time
                    }]
                }
                let parm = {
                    LangType: that.$processdata.getLang(),
                    list: arr
                }
                that.$http.urlpost('/Pur/RFQB/PurRFQPartColse', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            // 零件回退
            partBreak(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        part_key: that.selectData[i].part_key,
                        part_status: that.selectData[i].part_status,
                        part_modify_time: that.selectData[i].part_modify_time
                    }]
                }
                let parm = {
                    LangType: that.$processdata.getLang(),
                    list: arr
                }
                that.$http.urlpost('/Pur/RFQB/PurRFQPartBreak', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            // 报价审核
            purAudit(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        pur_key: that.selectData[i].pur_key,
                        pur_status: that.selectData[i].pur_status,
                        pur_modify_time: that.selectData[i].pur_modify_time
                    }]
                }
                let parm = {
                    LangType: that.$processdata.getLang(),
                    list: arr
                }
                that.$http.urlpost('/Pur/RFQB/PurRFQQAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            // 报价关闭
            purClose(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        pur_key: that.selectData[i].pur_key,
                        pur_status: that.selectData[i].pur_status,
                        pur_modify_time: that.selectData[i].pur_modify_time
                    }]
                }
                let parm = {
                    list: arr
                }
                that.$http.urlpost('/Pur/RFQB/PurRFQQClose', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            // 报价退回
            purBreak(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        pur_key: that.selectData[i].pur_key,
                        pur_status: that.selectData[i].pur_status,
                        pur_modify_time: that.selectData[i].pur_modify_time
                    }]
                }
                let parm = {
                    list: arr
                }
                that.$http.urlpost('/Pur/RFQB/PurRFQQBreak', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            /*批量查询价格表单*/
            // 获取数据
            getSearchView() {
                let that = this;
                that.loading = true;
                this.isVisibleSearch = false;
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: {
                        list: that.dataSearch
                    }
                };
                that.$http.urlpost('/Pur/RFQB/PurRFQViewBatchList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.isVisibleSearch = false;
                });
            },
            // 查询
            batchSearch() {
                let that = this
                that.dataSearch = []
                that.isVisibleSearch = true;
            },
            // 导出
            searchExp() {
                let that = this;
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: {
                        list: that.dataSearch
                    }
                };
                that.$http.urlpost('/Pur/RFQB/PurRFQViewBatchListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            //新增一行
            addsearch() {
                let that = this
                that.dataSearch = [...that.dataSearch,{
                    part_code: ''
                }]
            },
            delsearch() {
                let that = this;
                let selectRecords = this.$refs.search.getCheckboxRecords();
                for (let i = selectRecords.length - 1; i >= 0; i--) {
                    let line = this.$refs.search.getRowIndex(selectRecords[i]);
                    that.dataSearch.splice(line, 1);
                }
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if (this.$route.name == this.$options.name) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.checks(data);
                        }
                    }
                }
            },
            checks(datap) {
                let that = this
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 1) {
                        that.dataSearch = [...that.dataSearch, {
                            part_code: arr[i].split('\\t')[0],
                        }]
                    }
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
